module.exports = __webpack_public_path__ + "appengine.logo.a89a3.png";